import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { fetchServer } from "../Base/modelManager";
import moment from "moment";
import { Divider } from "antd";


class DernieresInfos extends React.Component {
    constructor(props) {
        super(props)

        this.refDiv = React.createRef()
        this.state = {
            lastInfos: []
        }
    }

    componentDidMount() {
        this.getLastInfo()
    }

    getLastInfo = () => {
        const currentDate = moment().format('YYYY-MM-DD')

        const request = {
            endPoint: this.props.apiUrl + '/EspaceClientInfo?$filter= dateDebut le ' + currentDate + ' and dateFin ge ' + currentDate,
            method: 'GET',
            token: this.props.JWTToken
        }

        fetchServer(request, (json) => {
            this.setState({ lastInfos: json.value })

        }, this.onError)

    }


    render() {

        return (
            <div className="row gy-4">
                <div className="col-xl-12 col-md-12 aos-init aos-animate" data-aos="fade-up" data-aos-delay="200">
                    <div className='HomeBlock'>
                        <h2>Dernières Informations</h2>
                        {/*<div ref={this.refDiv}>
                            {
                                this.props.url === 'btf' ?

                                    <table style={{ width: '100%' }}>
                                        <tbody >
                                            <tr >
                                                <td style={{ width: '80%' }}>Téléchargez l’application BTF MOBILITE pour savoir dans quelles stations vous pouvez faire le plein !
                                                    <br />Apple Store : <a href="https://apps.apple.com/fr/app/btf/id6480509620" >https://apps.apple.com/fr/app/btf/id6480509620</a>
                                                    <br />Google Play : <a href="https://play.google.com/store/apps/details?id=fr.android.btf&amp;hl=fr" >https://play.google.com/store/apps/details?id=fr.android.btf&amp;hl=fr</a>
                                                    <br />
                                                </td>
                                                <td style={{ width: '20%' }}>
                                                    <img alt='' src="/assets/images/qrcodeapp.jpg" style={{ width: '100px', display: 'block', verticalAlign: 'top', margin: '5px auto', textAlign: 'center', height: '100px', position: 'relative', maxWidth: '100%', cursor: 'pointer', padding: '0px 1px', boxSizing: 'border-box' }} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    : null
                            }


                        </div>
                        */}
                        {
                            this.state.lastInfos.map(item => {
                                const markup = { __html: item.html };
                                return <div key={item.id}>
                                    <Divider direction='horizontal' style={{margin:0}}></Divider>
                                    <div dangerouslySetInnerHTML={markup} style={{ width: '100%', textAlign: 'left' }}></div>
                                </div>
                            })
                        }
                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return ({
        JWTToken: state.authentication.JWTToken,
        apiUrl: state.server.apiUrl,
        url: state.app.url
    })
}

DernieresInfos.propTypes = {
    apiUrl: PropTypes.string,
    JWTToken: PropTypes.string,
    url: PropTypes.string
};

export default connect(mapStateToProps)(DernieresInfos);